import styled from "styled-components";

/**
 * Wrapper for editable blocks
 */
export const PaymentOptionStyled = styled.div`
  .icon {
      width:2.2rem;
      height: 2.2rem;
  }
  .icon-text {
    color: ${props => props.theme.lightGreen};
    font-weight: bold;
    font-size: 1.4rem;
  }
`;
